/**
 * Fetches a catalog collection served by the server's `/assets/*` routes
 * (skeleton types, characters, items). Responses are either a raw array or
 * `{ data: [...] }` (a paged collection envelope) depending on the route;
 * this normalizes both. Browser-only (uses `fetch`) - shared by
 * `CharacterLoader.initialize()` and any consumer that needs catalog data
 * without a full `CharacterLoader` instance (e.g. the client's gathering
 * asset-preload trigger, which runs before a Babylon `Scene` exists).
 */
export async function loadAssetCatalog<T>(url: string): Promise<T[]> {
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Failed to fetch asset catalog: ${url}`);
    }
    const payload = await response.json();
    return (payload?.data ?? payload) as T[];
}
